import { Injectable } from '@angular/core';
import { CodedEntity } from '@asm/features/sync/models/coded-entity.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/** Store: `payment_methods` | keyPath: `code` */
@Injectable({ providedIn: 'root' })
export class PaymentMethodRepository extends RepositoryBase<CodedEntity> {
  protected readonly KEY_PATH = 'payment_methods';
}
